module.exports = __webpack_public_path__ + "static/media/M1.76fd046e.mp4";